<template>
    <div>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white">
                Check Out - Payment
            </h1>
        </div>
        <div class="grid-container pad-top--large">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-7">
                    <div class="grid-x">
                        <div v-if="token.card === false" class="cell small-12 medium-8 medium-offset-1 pad-bottom">
                            <p class="lead pad-bottom">Please enter your payment card details below</p>
                            
                            <card
                                class='stripe-card'
                                v-bind:class='{ complete }'
                                stripe='pk_live_wF4udEJ0NihY5oxpgFjxpcGp001FSWrZxd'
                                v-on:change='complete = $event.complete'>
                                &nbsp;
                            </card>
                            
                            <!--
                            <card
                                class='stripe-card'
                                v-bind:class='{ complete }'
                                stripe='pk_test_VYPKTlpRJNN4C2Ulz8cMANu100n8Rnd9O1'
                                v-on:change='complete = $event.complete'>
                                &nbsp;
                            </card>
                            -->
                            
                            <p class="help-text form pad-top--xl">
                                By clicking "Submit your order" you agree to our
                                <a class="link" target="_blank" href="/terms">terms and conditions</a>
                                and <a class="link" target="_blank" href="/shipping-policy">
                                delivery and returns policy</a>. Your card will be charged
                                &pound;{{ (paymentTotal/100) | numeral('0,0.00') }}.
                            </p>
                            <p class="help-text form">
                                Please note your card will be charged immediately
                            </p>
                        </div>
                    </div>
                </div>
                <div class="cell small-12 medium-5 pad-bottom--xl">
                    <div class="bordered light shadowed pad">
                        <div class="cart-progress">
                            <span class="one active"></span>
                            <span class="two active"></span>
                            <span class="three active"></span>
                        </div>
                        <h5 class="text-right pad-top">Summary</h5>
                        <hr />
                        <div
                            v-for="(item, index) in basketContents"
                            v-bind:key="index"
                            class="grid-x">
                            <div class="cell small-12 medium-3">
                                <img
                                    v-bind:src="`https://our-catalogue.com/RUNS/images/${item.product_code}.jpg?width=100`"
                                    alt="" />
                            </div>
                            <div class="cell small-12 medium-6">
                                <p class="small text-light pad-left">
                                    {{ item.product_code }}
                                </p>
                                <p class="small text-light pad-left">
                                    Colour <span class="float-right">{{ item.colour }}</span><br />
                                    Size<br />
                                    <span
                                        v-for="(size, index) in item.size"
                                        v-bind:key="index"
                                        class="text-heavy">
                                        {{ size }}
                                    <br /></span>
                                    Method <span class="float-right">{{ item.method }}</span><br />
                                    Customize <span class="float-right">{{ item.design_id }}</span><br />
                                </p>
                            </div>
                            <div class="cell small-12 medium-3">
                                <p class="text-right text-heavy">
                                    &pound;{{ item.price + ( item.design_price / 100 ) | numeral('0,0.00') }} X {{ item.quantity }}
                                </p>
                            </div>
                            <div class="cell small-12">
                                <hr />
                            </div>
                        </div>
                        <table class="fixed">
                            <tbody>
                                <tr>
                                    <th>SubTotal</th>
                                    <td colspan="2" class="text-right">
                                        &pound;{{ basketSubTotal | numeral('0,0.00') }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>VAT</th>
                                    <td colspan="2" class="text-right">
                                        &pound;{{ basketVatTotal | numeral('0,0.00') }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Delivery</th>
                                    <td>&nbsp;</td>
                                    <td class="price-cell text-right">
                                        &pound;{{ deliveryPrice | numeral('0,0.00') }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Total</th>
                                    <td colspan="2" class="text-right">
                                        &pound;{{ (deliveryPrice + basketSubTotal + basketVatTotal) | numeral('0,0.00') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button
                            class="button tall green expanded"
                            v-on:click='pay'
                            v-on:disabled='!complete'>Submit your order
                        </button>
                        <p
                            class="lead text-center"
                            v-if="message.length > 0">{{ message }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="processing === true"
            class="loading-overlay">
            <p>Your payment is processing, please wait</p>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line
import { Card, handleCardPayment } from 'vue-stripe-elements-plus';
import axios from '../../axios';

export default {
    name: 'Payment',
    components: {
        Card,
    },
    data() {
        return {
            complete: false,
            token: {
                card: false,
            },
            intent: '',
            processing: false,
            message: '',
        };
    },
    computed: {
        paymentTotal() {
            let total = this.$store.getters.paymentTotal;
            total = Math.round(total);
            return total;
        },
        deliveryType() { return this.$store.getters.delivery; },
        basket() { return this.$store.getters.basketId; },
        deliveryAddress() { return this.$store.getters.deliveryAddress; },
        invoiceAddress() { return this.$store.getters.invoiceAddress; },
        basketContents() { return this.$store.getters.basketItems; },
        basketSubTotal() { return this.$store.getters.basketSubTotal; },
        deliveryPrice() { return this.$store.getters.deliveryPrice; },
        basketVatTotal() { return this.$store.getters.basketVatTotal; },
    },
    methods: {
        createIntent() {
            axios.get(`/Stripe/createIntent.json?amount=${this.paymentTotal}`)
                .then((response) => {
                    this.intent = response.data.intent.client_secret;
                },
            );
        },
        pay() {
            this.processing = true;
            handleCardPayment(this.intent)
            .then((data) => {
                const status = data.paymentIntent.status;
                if (typeof status !== 'undefined') {
                    if (status === 'succeeded') {
                        this.updateOrder();
                    } else {
                        // eslint-disable-next-line
                        this.message = 'Your payment could not be processed. Please check your card details and try again.';
                        this.processing = false;
                    }
                }
            });
        },
        updateOrder() {
            const postData = {};
            postData.deliveryType = this.deliveryType;
            postData.basket = this.basket;
            postData.deliveryAddress = this.deliveryAddress;
            postData.invoiceAddress = this.invoiceAddress;
            postData.paymentTotal = this.paymentTotal;
            axios.post('/Shop/createOrder.json', postData)
            .then(() => {
                this.$router.push('/checkout/thankyou');
            });
        },
    },
    mounted() {
        this.createIntent();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/CheckOut/Payment.vue